import React, { createElement, useEffect } from "react";
import parse from 'html-react-parser';
import ReactDOM from 'react-dom';
import Dimensions from "../Dimensions/Dimensions";

const SubmenuList = (props) => {

  const { subMenuList } = props;
  const filterMenuBasedOnConfigType = props.filterMenuBasedOnConfigType;
  const hasRadioButton = subMenuList.some(item => item.menuType === "radioButton");
  const [activeBtn, setActiveBtn] = React.useState("firstButton");
  // const [activeBtn, setActiveBtn] = React.useState(null);
  // 

  // let filteredSubmenuList = subMenuList.filter(filterMenuBasedOnConfigType);
  const filteredSubmenuList = subMenuList.filter(
    item =>
      item.subMenuVisibility !== false &&
      filterMenuBasedOnConfigType(item)
  );
  // useEffect(() => {
  //   window.setPopupButtonForSubmenu = (submenuId, buttonId) => {
  //     setActiveBtn(prev => ({
  //       ...prev,
  //       [submenuId]: buttonId
  //     }));
  //   };

  //   return () => {
  //     delete window.setPopupButtonForSubmenu;
  //   };
  // }, []);

  // filteredSubmenuList = subMenuList.filter(submenu => submenu.subMenuVisibility !== false);

  return (
    <div className="accordionContent" data-id={props.accordionId}>
      <ul className="subMenu" aria-hidden="true" role={hasRadioButton ? "radiogroup" : undefined}>
        {filteredSubmenuList.map((list, listIndex) => {
          const hasValidDimensions = (Array.isArray(list.hotspotDataInfo) && list.hotspotDataInfo.length > 0) || (typeof list.hotspotDataInfo === "string" && list.hotspotDataInfo.trim() !== "");
          const indexOfListinAllSubMenu = window.config.allSubmenu.findIndex(element => element.id === list.id);
          const popupButtons = list.popupBoxButtons?.[0] || {};
          const firstButton = popupButtons.firstButton;
          const secondButton = popupButtons.secondButton;
          let activePopupContent = null;

          if (activeBtn === "firstButton") {
            activePopupContent = firstButton?.content || [];
          } else if (activeBtn === "secondButton") {
            activePopupContent = secondButton?.content || [];
          }


          if (indexOfListinAllSubMenu === -1) { window.config.allSubmenu.push(list); }
          // const indexOfListinNextPreviousArray = window.config.nextPrevArray.findIndex(element => element.id === list.id);

          // if(indexOfListinNextPreviousArray === -1 && list.type !== "ProductType") {
          //   window.config.nextPrevArray.push({ ...list, type: 'submenu' });

          //   // Add dimensions to nextPrevArray if present
          //   if (list.hotspotDataInfo && Array.isArray(list.hotspotDataInfo) && list.hotspotDataInfo.length > 0 && window.config.dimensions) {
          //     list.hotspotDataInfo.forEach(dim => {
          //       window.config.nextPrevArray.push({ ...dim, type: 'dimension', id: dim.htmlid || dim.hsname, parentSubmenuId: list.id });
          //     });
          //   }
          // }

          let isActive = false;
          let filteredCallouText = '';
          let filteredCallouText1 = '';
          let listHasCalloutText = list.content != undefined && list.content.length > 0;

          if (listHasCalloutText) filteredCallouText = list.content.filter(filterMenuBasedOnConfigType);
          if (listHasCalloutText) filteredCallouText1 = list.content1?.filter(filterMenuBasedOnConfigType) || [];
          // const haspopupButtonsSwitch = filteredCallouText?.some(item => item.firstButton || item.secondButton);
          const haspopupButtonsSwitch = Array.isArray(list.popupBoxButtons) && list.popupBoxButtons.length > 0 && (list.popupBoxButtons[0].firstButton || list.popupBoxButtons[0].secondButton);

          // Filter hotspot content separately
          let filteredHotspotContent = [];
          let hotspotHeading = ''; // Store hotspot heading
          if (list.hotspotDataInfo && Array.isArray(list.hotspotDataInfo) && list.hotspotDataInfo.length > 0) {
            list.hotspotDataInfo.forEach(hotspot => {
              // Get heading from first hotspot item (or you can customize this logic)
              if (!hotspotHeading && hotspot.popupHeading) {
                hotspotHeading = hotspot.popupHeading; // Use popupId as heading or any other field
              }
              if (hotspot.content && Array.isArray(hotspot.content)) {
                const filtered = hotspot.content.filter(filterMenuBasedOnConfigType);
                filteredHotspotContent = filteredHotspotContent.concat(filtered);
              }
            });
          }

          if (list.menuType == "radioButton") {
            isActive = (window.selectedConfig[list.featureType] == list.id);
          } else {
            if (window.isMobIsipadIsPotrait) {
              let isSubmenuAlreadySelectedForMobIpadPortrait = window.isMobIsipadIsPotrait && (window.selectedConfig['submenu_' + list.type] !== window.selectedConfig['previous_submenu_' + list.type]);
              isActive = window.selectedConfig['submenu_' + list.type] == list.id && isSubmenuAlreadySelectedForMobIpadPortrait;
            } else {
              let accordionMenu = document.querySelector("#accordion_" + list.type);
              let isAccordionActive = accordionMenu ? accordionMenu.classList.contains('active') : false;
              isActive = (window.selectedConfig['submenu_' + list.type] == list.id) && isAccordionActive;
            }
          }

          let listMedia = list.media != undefined ? list.media[0] : {};
          let desktopPopupLeft = 0;
          let desktopPopupTop = 0;
          let desktopPopupWidth = 0;
          let desktopPopupHeight = 0;

          if (Object.keys(listMedia).length != 0) {
            desktopPopupLeft = listMedia[window.UiUtils.getResolution()]['left'];
            desktopPopupTop = listMedia[window.UiUtils.getResolution()]['top'];
            desktopPopupWidth = listMedia[window.UiUtils.getResolution()]['width'];
            desktopPopupHeight = listMedia[window.UiUtils.getResolution()]['height'];
          }
          // Hotspot Media
          let hotspotMedia = null;
          let hotspotPopupLeft = desktopPopupLeft;
          let hotspotPopupTop = desktopPopupTop;
          let hotspotPopupWidth = desktopPopupWidth;
          let hotspotPopupHeight = desktopPopupHeight;

          if (list.hotspotDataInfo && Array.isArray(list.hotspotDataInfo) && list.hotspotDataInfo.length > 0) {
            const firstHotspot = list.hotspotDataInfo[0];
            if (firstHotspot.media && firstHotspot.media[0]) {
              hotspotMedia = firstHotspot.media[0];
              const resolution = window.UiUtils.getResolution();
              if (hotspotMedia[resolution]) {
                hotspotPopupLeft = hotspotMedia[resolution]['left'];
                hotspotPopupTop = hotspotMedia[resolution]['top'];
                hotspotPopupWidth = hotspotMedia[resolution]['width'];
                hotspotPopupHeight = hotspotMedia[resolution]['height'];
              }
            }
          }
          let popupStyle = {
            left: `calc(0px + ${desktopPopupLeft})`,
            top: desktopPopupTop,
            width: desktopPopupWidth,
            height: desktopPopupHeight,
          }
          let hotspotPopupStyle = {
            left: `calc(0px + ${hotspotPopupLeft})`,
            top: hotspotPopupTop,
            width: hotspotPopupWidth,
            height: hotspotPopupHeight,
          }
          window.menuSubmenuTabindex = props.parentIndex + 1 + listIndex;

          const submenuProps = {};

          if (list.menuType !== "radioButton") {
            submenuProps["aria-label"] = list.title;
            submenuProps["role"] = "button";
            submenuProps["aria-current"] = isActive ? 'true' : "false";
            submenuProps["aria-selected"] = isActive ? 'true' : "false";
          }

          return (
            list.subMenuVisibility && (
              <React.Fragment key={list.id}>
                <li
                  key={list.id}
                  tabIndex={-1}
                  data-tabindex={list.menuType === "radioButton" ? -1 : 1}
                  defaultChecked={true}
                  className={`subMenuBtn ${list.menuType} ${isActive ? 'active' : ''} ${!listHasCalloutText ? 'withoutArrow' : ''} ${haspopupButtonsSwitch ? 'withbutton' : ''}`}
                  id={`menu_id_${list.id}`}
                  {...submenuProps}
                  onKeyDown={(e) => {
                    if (e.key !== "Enter") {
                      return;
                    }
                    setActiveBtn("firstButton"); // 👈 default to secondButton on keyboard selection
                    props.handleSubMenuClick(list);
                  }}
                  onClick={(event) => {
                    setActiveBtn("firstButton"); // 👈 default to secondButton on click
                    props.handleSubMenuClick(list, list.id);
                  }}
                >
                  {list.menuType === "radioButton" ? (
                    <>
                      <input
                        type={"radio"}
                        role={"radio"}
                        value={"product1"}
                        tabIndex={-1}
                        data-tabindex={1}
                        id={list.radioId}
                        className="radioFocus"
                        name={list.radioName}
                        aria-checked={`${isActive ? 'true' : "false"}`}
                        checked={isActive}
                        onChange={(e) => {
                          props.handleSubMenuClick(list, list.id);
                        }}
                      />
                      <label id={"label_" + list.radioId} htmlFor={list.radioId} data-contentwidth={props.calcHtmlElementNoWrapWidth(list.title, props.cssVariableValues.submenuTextFontSize)}> {list.title}</label>
                    </>
                  ) : ((window.mob || window.innerHeight > window.innerWidth)) || window.innerWidth < 935 ? (
                    <>
                      {(window.isMobIsipadIsPotrait) && (
                        <svg width="32" height="32" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" className="chevron" aria-hidden="true" focusable="false" strokeWidth="6" stroke="#000000" fill="none"><polyline points="18.86 57.47 44.12 30.84 18.86 6.58" /></svg>
                      )}
                      <span className="subMenuBtnText" data-contentwidth={props.calcHtmlElementNoWrapWidth(list.title, props.cssVariableValues.submenuTextFontSize)}>{parse(list.title)}</span>
                    </>
                  ) : (
                    <span className="subMenuBtnText" data-contentwidth={props.calcHtmlElementNoWrapWidth(list.title, props.cssVariableValues.submenuTextFontSize)}>
                      {parse(list.title)}</span>
                  )}
                </li>

                {/* Mobile/iPad Portrait Callout - Submenu Content Only */}
                {(window.isMobIsipadIsPotrait && (listHasCalloutText || (filteredHotspotContent && filteredHotspotContent.length > 0))) &&
                  <div className="callout">
                    <h2 className="calloutHeading">{parse(list.popupHeading)} </h2>

                    {/* Original Submenu Content */}
                    {/* Original Submenu Content – SAME AS DESKTOP */}
                    {filteredCallouText && filteredCallouText.length > 0 && (
                      <div className="content">
                        {(() => {
                          const sourceContent =
                            haspopupButtonsSwitch && activePopupContent
                              ? activePopupContent
                              : filteredCallouText;

                          const validCallouts = sourceContent.filter(item => item.text);
                          if (validCallouts.length === 0) return null;

                          const bulletItems = validCallouts.filter(item => item.styleType === "bullet");
                          const numberedItems = validCallouts.filter(item => item.styleType === "numbered");
                          const titleBoldItems = validCallouts.filter(item => item.styleType === "titleBold");

                          return (
                            <>
                              {/* Title Bold */}
                              {titleBoldItems.map((calloutText, i) => (
                                <span key={`titleBold-${i}`} className="textHeadline">
                                  {parse(calloutText.text)}
                                </span>
                              ))}

                              {/* Bullet List */}
                              {/* Bullet List */}
                              {validCallouts.length > 0 && (
                                <ul>
                                  {validCallouts.map((item, i) => (
                                    <li key={i} className="bulletItem">
                                      {parse(item.text)}
                                    </li>
                                  ))}
                                </ul>
                              )}


                              {/* Numbered List */}
                              {/* Numbered List */}
                              {numberedItems.length > 0 && (
                                <ol>
                                  {numberedItems.map((calloutText, i) => (
                                    <li key={`numbered-${i}`} className="numberItem">
                                      {parse(calloutText.text)}

                                      {Array.isArray(calloutText.subText) && calloutText.subText.length > 0 && (
                                        <ul className="subTextList">
                                          {calloutText.subText.map((sub, subIndex) => (
                                            <li key={subIndex} className="subTextItem">
                                              {parse(sub)}
                                            </li>
                                          ))}
                                        </ul>
                                      )}
                                    </li>
                                  ))}
                                </ol>
                              )}

                            </>
                          );
                        })()}
                      </div>
                    )}


                    {/*Hotspot Content Clickable */}
                    {list.hotspotDataInfo?.length > 0 && (
                      list.hotspotDataInfo.map((hotspot, hIndex) => {
                        const filteredHotspotContent = hotspot.content?.filter(filterMenuBasedOnConfigType) || [];
                        if (!filteredHotspotContent.length) return null;

                        return (
                          <div
                            key={hotspot.hsname || hIndex}
                            className="hotspot-content-mobile-clickable"
                            role="button"
                            tabIndex={0}
                            onClick={(e) => {
                              e.stopPropagation();
                              props.handleHotspotClick(list.id, list.hotspotDataInfo, true, hotspot.hsname);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") props.handleHotspotClick(list.id, list.hotspotDataInfo, true, hotspot.hsname);

                            }}
                          >
                            {hotspot.popupHeading && (
                              <h2 className="calloutHeading">{parse(hotspot.popupHeading)}</h2>
                            )}

                            <ul style={{ margin: 0 }}>
                              {filteredHotspotContent.map((textItem, index) => {
                                if (!textItem.text) return null;
                                return (
                                  <React.Fragment key={index}>
                                    <li>{parse(textItem.text)}</li>
                                    {Array.isArray(textItem.subText) && (
                                      <ul className="subTextList">
                                        {textItem.subText.map((sub, subIndex) => (
                                          <li key={subIndex} className="subTextItem">{parse(sub)}</li>
                                        ))}
                                      </ul>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                            </ul>
                          </div>
                        );
                      })
                    )}


                    {/* Content1 (disclaimer) */}
                    {(list.content1 != undefined && list.content1.length > 0) && filteredCallouText1.map((calloutText) => {
                      return (
                        <React.Fragment key={Math.random()}>
                          {<div className="content1">
                            <p className="disclaimerItalics">{parse(calloutText.text1)}</p>
                          </div>}
                        </React.Fragment>
                      )
                    })}

                    {/* Top / Bottom buttons */}
                    {(firstButton || secondButton) && (
                      <div className="popupButtonsSwitch">
                        {[firstButton, secondButton].map((btn) => {
                          if (!btn) return null;
                          return (
                            <button
                              key={btn.id}
                              id={btn.id}
                              className={`switchBtn ${btn.classList || ""} ${activeBtn === btn.id ? "active" : ""
                                }`}

                              onClick={(e) => {
                                e.stopPropagation();
                                setActiveBtn(btn.id); // 👈 current ko active
                                props.popupButtonClicks(btn);
                              }}
                            >
                              {btn.text}
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                }

                {/* Desktop/Landscape Submenu Content Popup */}
                {((window.deviceBasedonBodyClass == 'desktop' || window.deviceBasedonBodyClass == 'ipadDesktopLandscape' || window.deviceBasedonBodyClass == 'ipadLandscape' || window.deviceBasedonBodyClass == 'androidTabLandscape') && (list.content != undefined && list.content.length != 0)) &&
                  ReactDOM.createPortal(<div className={`popup ${(window.selectedConfig['currentSelectedSubmenu'] === list.id || window.selectedConfig['currentSelectedSubmenu'] === 'firstButton' || window.selectedConfig['currentSelectedSubmenu'] === 'secondButton') && haspopupButtonsSwitch ? 'active' : (window.selectedConfig['currentSelectedSubmenu'] === list.id ? 'active' : '')} ${haspopupButtonsSwitch ? 'withbutton' : ''}`} role='dialog' id={list.popupId} style={popupStyle}>
                    <h2>{parse(list.popupHeading)} </h2>
                    <div className="content">
                      {(() => {
                        const sourceContent =
                          haspopupButtonsSwitch && activePopupContent
                            ? activePopupContent
                            : filteredCallouText;

                        const validCallouts = sourceContent.filter(item => item.text);
                        if (validCallouts.length === 0) return null;

                        const bulletItems = validCallouts.filter(item => item.styleType === "bullet");
                        const numberedItems = validCallouts.filter(item => item.styleType === "numbered");
                        const titleBoldItems = validCallouts.filter(item => item.styleType === "titleBold");

                        return (
                          <>
                            {/* Title Bold */}
                            {titleBoldItems.map((item, i) => (
                              <span key={`titleBold-${i}`} className="textHeadline">
                                {parse(item.text)}
                              </span>
                            ))}

                            {/* Bullet List */}
                            {bulletItems.length > 0 && (
                              <ul>
                                {bulletItems.map((item, i) => (
                                  <li key={`bullet-${i}`} className="bulletItem">
                                    {parse(item.text)}
                                  </li>
                                ))}
                              </ul>
                            )}

                            {/* Numbered List */}
                            {numberedItems.length > 0 && (
                              <ol>
                                {numberedItems.map((item, i) => (
                                  <li key={`numbered-${i}`} className="numberItem">
                                    {parse(item.text)}
                                  </li>
                                ))}
                              </ol>
                            )}
                          </>
                        );
                      })()}


                      {(list.content1 != undefined && list.content1.length > 0) && filteredCallouText1.map((calloutText) => (
                        <React.Fragment key={Math.random()}>
                          <div className="content1">
                            <p className="disclaimerItalics">{parse(calloutText.text1)}</p>
                          </div>
                        </React.Fragment>
                      ))}
                    </div>
                    {/* Top / Bottom buttons */}
                    {(firstButton || secondButton) && (
                      <div className="popupButtonsSwitch">
                        {[firstButton, secondButton].map((btn) => {
                          if (!btn) return null;
                          return (
                            <button
                              key={btn.id}
                              id={btn.id}
                              className={`switchBtn ${btn.classList || ""} ${activeBtn === btn.id ? "active" : ""
                                }`}

                              onClick={(e) => {
                                e.stopPropagation();
                                setActiveBtn(btn.id); // 👈 current ko active
                                props.popupButtonClicks(btn);
                              }}
                            >
                              {btn.text}
                            </button>
                          );
                        })}
                      </div>
                    )}


                  </div>, document.getElementById('popupContainer'))
                }

                {/* Hotspot Popup */}
                {((window.deviceBasedonBodyClass == 'desktop' || window.deviceBasedonBodyClass == 'ipadDesktopLandscape' || window.deviceBasedonBodyClass == 'ipadLandscape' || window.deviceBasedonBodyClass == 'androidTabLandscape') && filteredHotspotContent && filteredHotspotContent.length > 0) &&
                  ReactDOM.createPortal(
                    <div
                      className={`popup ${window.selectedConfig['currentSelectedHotspot'] === list.id ? 'active' : ''}`}
                      role='dialog'
                      id={`hotspot_popup_${list.id}`}
                      style={hotspotPopupStyle}
                    >
                      <h2>{parse(hotspotHeading)}</h2>
                      <div className="content">
                        <ul>
                          {filteredHotspotContent.map((hotspotText, index) => {
                            if (!hotspotText.text) return null;
                            return (
                              <React.Fragment key={`hotspot-${index}`}>
                                {Array.isArray(hotspotText.subText) && hotspotText.subText.length > 0 ? (
                                  <span className="textHeadline">{parse(hotspotText.text)}</span>
                                ) : (
                                  <li>{parse(hotspotText.text)}</li>
                                )}

                                {Array.isArray(hotspotText.subText) && hotspotText.subText.length > 0 && (
                                  <ul className="subTextList">
                                    {hotspotText.subText.map((sub, subIndex) => (
                                      <li key={subIndex} className="subTextItem">
                                        {parse(sub)}
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </ul>
                      </div>
                    </div>,
                    document.getElementById('popupContainer')
                  )
                }




                {/* Dimensions component */}
                {/* {hasValidDimensions && ( */}
                {hasValidDimensions && !window.isMobIsipadIsPotrait && (

                  <Dimensions
                    list={list}
                    handleHotspotClick={props.handleHotspotClick}
                  />
                )}

              </React.Fragment>
            )
          );
        })}
      </ul>
    </div>
  );
};

export default SubmenuList;
